import {css, StyleSheet} from 'aphrodite';
import React, {useState, useEffect} from 'react';

import MonomerConfigurationPageContainer, {
  MONOMER_CONFIGURATION_PURPOSE,
} from 'molbio/monomers/admin/MonomerConfigurationPageContainer';
import AliasCreationForm from 'molbio/monomers/custom-syntax/AliasCreationForm';
import AliasTable, {updateAliases} from 'molbio/monomers/custom-syntax/AliasTable';
import {AliasData, createIDTAliases, getIDTAliases} from 'molbio/monomers/MonomersDAO';

export default function IdtTableAndForm({hideNavHeader}: {hideNavHeader?: boolean}): JSX.Element {
  const [IDTAliases, setIDTAliases] = useState<Array<AliasData>>([]);
  useEffect(() => {
    const fetchIDTAliases = async (): Promise<void> => {
      const resp = await getIDTAliases();
      setIDTAliases(resp);
    };
    fetchIDTAliases();
  }, []);

  return (
    <>
      {hideNavHeader ? (
        <h1 id="idt-section">IDT Aliases</h1>
      ) : (
        <MonomerConfigurationPageContainer purpose={MONOMER_CONFIGURATION_PURPOSE.IDT_ALIASES} />
      )}
      <div className={css(styles.idtTableAndForm)}>
        <div className="u-flex-display u-spacing-bottom">
          <div className="idtForm">
            <AliasCreationForm
              syntaxName="IDT"
              updateLocalState={(newAliases) => {
                setIDTAliases((oldAliases) => [...oldAliases, ...newAliases]);
              }}
              onSubmit={(formText) => createIDTAliases(formText)}
            />
          </div>
          <div className="idtTable">
            <AliasTable
              aliases={IDTAliases}
              syntaxName="IDT"
              updateLocalState={(updatedAlias: AliasData, isDelete: boolean = false) => {
                setIDTAliases(updateAliases(updatedAlias, IDTAliases, isDelete));
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

const styles = StyleSheet.create({
  idtTableAndForm: {
    marginLeft: 40,
    marginRight: 40,
    flex: 1,
    flexDirection: 'column',
    display: 'flex',
  },
});
